<template>
  
    <b-container>
      <b-row>
        <b-col
          cols="12"
          sm="12"
          md="12"
          lg="5"
          class="bg-white section__border-radius"
        >
          <b-row>
            <b-col cols="6" class="section__filter_border">
              <label class="m-0 text-small" for="">Sucursal</label>
              <slot name="sucursal"> </slot>
            </b-col>
            <b-col cols="6">
              <label class="m-0 text-small" for="">Doc. Identidad</label>
              <slot name="params"> </slot>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="2" sm="12" md="12" lg="2">
          <slot name="button"> </slot>
        </b-col>
        <b-col
          cols="12"
          sm="12"
          md="12"
          lg="5"
          :class="'float-right main__section_title_color '+showCambiarFlujo"
        >
          <b-button
            :to="{ name: 'CreacionOs' }"
            class="section__button_trans border-none"
          >
            <span> <font-awesome-icon icon="sync-alt" /> </span> Cambiar flujo
          </b-button>
        </b-col>
      </b-row>
    </b-container>
 
</template>
<script>
export default {
  name: "SearchGeneric",
  props:{
    showCambiarFlujo:{
      type:String
    }
  }
};
</script>
<style scoped>
.hidden{visibility: hidden;}
</style>